import React from "react";

const UnreadIcon = ({ color = "black" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.834 7.16663C17.2147 7.16663 18.334 6.04734 18.334 4.66663C18.334 3.28591 17.2147 2.16663 15.834 2.16663C14.4533 2.16663 13.334 3.28591 13.334 4.66663C13.334 6.04734 14.4533 7.16663 15.834 7.16663Z"
        stroke={color}
      />
      <path
        d="M1.66699 11.3333H4.30033C5.05449 11.3333 5.43199 11.3333 5.76366 11.4858C6.09533 11.6383 6.34033 11.9249 6.83116 12.4974L7.33616 13.0858C7.82699 13.6583 8.07199 13.9449 8.40366 14.0974C8.73533 14.2499 9.11199 14.2499 9.86699 14.2499H10.1337C10.8878 14.2499 11.2653 14.2499 11.597 14.0974C11.9287 13.9449 12.1737 13.6583 12.6645 13.0858L13.1695 12.4974C13.6603 11.9249 13.9053 11.6383 14.237 11.4858C14.5687 11.3333 14.9453 11.3333 15.7003 11.3333H18.3337"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M1.66699 10.5C1.66699 14.4283 1.66699 16.3925 2.88699 17.6125C4.10866 18.8333 6.07199 18.8333 10.0003 18.8333C13.9287 18.8333 15.8928 18.8333 17.1128 17.6125C18.3337 16.3933 18.3337 14.4283 18.3337 10.5C18.3342 9.90051 18.3328 9.34496 18.3295 8.83329M11.667 2.17079C11.1553 2.16801 10.5998 2.16663 10.0003 2.16663C6.07199 2.16663 4.10783 2.16663 2.88699 3.38663C2.07616 4.19829 1.80366 5.33913 1.71283 7.16663"
        stroke={color}
        stroke-linecap="round"
      />
    </svg>
  );
};

export default UnreadIcon;
